export default "__VITE_ASSET__CdulzS5K__"